﻿/**
 * Created by jehe on 01.03.2022.
 * Sosi import: https://github.com/atlefren/sosi.js
 * GDB import: https://github.com/calvinmetcalf/fileGDB.js/
 * Shp import: https://github.com/calvinmetcalf/shapefile-js
 */
import creator from '../elementCreator';
import globals from '../globals';

import Style from 'ol/style/Style.js';
import Stroke from 'ol/style/Stroke.js';
import Fill from 'ol/style/Fill.js';
import Circle from 'ol/style/Circle.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import Vector from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';

import cw from "catiline"; 
import shp from "shpjs/dist/shp.js";


"use strict";
var privateFns, mapInteractions, clickFns, parameters, remove;
parameters = {
	selectedColor: "black",
	interaction: undefined,
	btn: undefined,
},
mapInteractions = {
	getActiveInteractions: function () {
		var interactions = {};
		globals.map.getInteractions().forEach(function (i) {
			if (i.get("itype") === "draw") {
				interactions.measureInteraction = i;
			} else if (i.get("interactionId") === "featurehover") {
				interactions.mapHoverInteraction = i;
			} else if (i.get("featurehover") === "featureclick") {
				interactions.mapClickInteraction = i;
			}
		});
		return interactions;
	},
},
privateFns = {
	updateSliderPanel: function(){
		document.getElementById("slider-container").innerHTML = "";
		let activeLayers = privateFns.getActiveLayers(globals.map.getLayers());
		activeLayers.forEach(function(layer){				
			document.getElementById("slider-container").appendChild(privateFns.addImportLayer(layer));
		});
	},
	getActiveLayers: function(layers){
		var activeLayers = [];
		layers.forEach(function(layer){
			let id = layer.get("layerId");
			if(!layer.getLayers && document.getElementById(id) && id !== "situasjon" && id !== "no_historisk_flyfoto" && id !== "text1" && document.getElementById(id).checked){
				activeLayers.push(layer);
			}else if(layer.getLayers){
				activeLayers = [...activeLayers, ...privateFns.getActiveLayers(layer.getLayers())];
			}
		});
		return activeLayers;
	},
	addImportControlPanel(){
		let activeLayers = privateFns.getActiveLayers(globals.map.getLayers());
		//activeLayers = activeLayers.splice(0, 1)
		
		var panel, dropPanel, infoBtn, removeBtn;
		panel = creator.createDiv({
			css: "map-writer-panel",
			id: "map-import-container",
		});
		dropPanel = creator.createDiv({
			text: "Dra og slipp for å importere filer.</br> GeoJSON(.json), shp(.shp.zip), sosi(.sos), gdb(gdb.zip)",
			css: "map-drop-panel",
			id: "map-import-panel",
		});
		infoBtn = creator.createButton({
			icon: true,
			iconClass: "icon-Informasjon",
			ariaLabel: "Info om verktøy",
			id: "import-info-btn",
			onclick: function(evt){
				$("#planinnsyn-hjelp").click();
				$("#tool-info-btn").click();
			}
		});
		infoBtn.style.float = "right";
		panel.appendChild(infoBtn);
		panel.appendChild(dropPanel);
		let layerList = creator.createUl({id: "layer-list"});
		layerList.style.listStyleType = "none";
		layerList.style.paddingLeft = 0;
		panel.appendChild(layerList);
		
		document.getElementById("map").appendChild(panel);
		panel.addEventListener('dragover', function(e) {
			e.stopPropagation();
			e.preventDefault();
			e.dataTransfer.dropEffect = 'copy';
			dropPanel.classList.add("map-drop-active");
		});
		panel.addEventListener('dragleave', function(e) {
			e.stopPropagation();
			e.preventDefault();
			e.dataTransfer.dropEffect = 'copy';
			dropPanel.classList.remove("map-drop-active");
		});
		panel.addEventListener('drop', function(e) {
			dropPanel.classList.remove("map-drop-active");
			privateFns.importFile(e);
		});
		
		$("#map-import-container").show();
	},
	importFile: function(e){
		e.stopPropagation();
		e.preventDefault();
		document.getElementById("map-import-panel").innerHTML = "<i class='layerloader fa fa-spinner fa-pulse'></i>";
		var files = e.dataTransfer.files; // Array of all files
		for (var i=0, file; file=files[i]; i++) {
			var reader = new FileReader();
			reader.fileName = file.name;
			reader.onload = function(file) {
				let format = file.target.fileName.split(".")[1];
				let infoPanel = creator.createDiv({id: "feature-info-panel", css: "feature-info-panel"});
				document.getElementById("map-import-container").prepend(infoPanel); 
				if(format == "json"){
					privateFns.addLayer((new GeoJSON()).readFeatures(file.target.result), file.target.fileName.split(".")[0]);
				}else if (format == "sos"){
					privateFns.addLayer((new GeoJSON()).readFeatures(new SOSI.Parser().parse(file.target.result).dumps("geojson")), file.target.fileName.split(".")[0]);
				}else if (format == "gml"){
					//TODO
				}else if(format == "shp"){
					shp(file.target.result).then(function(data){
						if(typeof data.forEach === "function"){
							data.forEach(function(featureLayer){
								var features = [];
								(new GeoJSON()).readFeatures(featureLayer).forEach(function (f, id){
									f.getGeometry().transform("EPSG:4326","EPSG:32632");
									features.push(f);
								});
								privateFns.addLayer(features, featureLayer.fileName);
							});
						}else{
							var features = [];
							(new GeoJSON()).readFeatures(data).forEach(function (f, id){								
								f.getGeometry().transform("EPSG:4326","EPSG:32632");
								features.push(f);
							});
							privateFns.addLayer(features, file.target.fileName.split(".")[0]);
						}
					});
				}else if(format == "gdb"){
					fgdb(file.target.result).then(function(data){
						for(var featureType in data){
							var features = [];
							(new GeoJSON()).readFeatures(data[featureType]).forEach(function (f, id){
								f.getGeometry().transform("EPSG:4326","EPSG:32632");
								features.push(f);
							});
							privateFns.addLayer(features, featureType);
						}
						document.getElementById("map-import-panel").innerHTML = "GeoJSON(.json), shp(.shp.zip), sosi(.sos), gdb(gdb.zip)";
					},function(a){console.log(a);});
				}else{
					document.getElementById("map-import-panel").innerHTML = "Ugyldig format!";
				}
			}
			if (file.name.slice(-3) === 'zip') {
				reader.readAsArrayBuffer(file);
			}else {		
				reader.readAsText(file); // start reading the file data. Encoding: reader.readAsText(file, encoding);
			}
		}
		let selected = null;
		let editing = false;
		var lastTime = new Date();
		globals.map.on('pointermove', function (e) {
			let selectStyle = new Style({
				fill: new Fill({
					color: 'rgba(238,238,238,0.7)',
				}),
				stroke: new Stroke({
					color: 'rgba(255, 255, 255, 1)',
					width: 2,
				}),
				image: new Circle({
					radius: 7,
					fill: new Fill({color: "#6FE9FF"}),
					stroke: new Stroke({
						color: "#FFFFFF",
						width: 2,
					})
				})
			});
			let selectStyle2 = new Style({
				fill: new Fill({
					color: '#2A2859',
				}),
				stroke: new Stroke({
					color: '#F9C66B',
					width: 2,
				}),
				image: new Circle({
					radius: 7,
					fill: new Fill({color: "#2A2859"}),
					stroke: new Stroke({
						color: "#F9C66B",
						width: 2,
					})
				})
			});
			if(selected != null) {
				selected.setStyle(undefined);
				selected = null;
			}
			globals.map.forEachFeatureAtPixel(e.pixel, function (f, layer) {
				if(!editing){
					selected = f;
					f.setStyle(selectStyle);
					document.getElementById("feature-info-panel").innerHTML = "";
					Object.entries(selected.values_).forEach(([key, value]) => {
						let prop = creator.createDiv({text: key + ":" + value, css: "feature-property"});
						prop.value = {"key": key, "value": value};
						prop.onclick = function(){
							if(typeof value == "string" && (parseInt(value).toString() === "NaN")){
								editing = true;
								$('.feature-property').not(this).hide();
								let clickedProperty = this;
								clickedProperty.innerHTML = key;
								let sortedFeatures = privateFns.getAllFeatureWithKey(key, layer);
								Object.entries(sortedFeatures).forEach(([key2, value2]) => {
									let selectedFeatureTypeDiv = creator.createDiv({text: key2, css: "feature-property"});
									//selectedFeatureTypeDiv.appendChild(privateFns.createColorStyleContainer());
									$(selectedFeatureTypeDiv).on("mouseenter",function(){
										sortedFeatures[key2].forEach(function(sortedFeature){
											sortedFeature.setStyle(selectStyle2);
										});
									});
									$(selectedFeatureTypeDiv).on("mouseleave",function(){
										sortedFeatures[key2].forEach(function(sortedFeature){
											sortedFeature.setStyle(undefined);
										});
									});
									/*$(selectedFeatureTypeDiv).on("click", function(e){
										if(!$(this).children(".styleContainer").is(":visible")){
											$(".styleContainer").hide();
											$(this).children(".styleContainer").show();		
											$(".blankSpace").show();										
										}else{												
											$(".blankSpace").hide();
											$(".styleContainer").hide();
										}
										e.stopPropagation();
									});*/
									prop.appendChild(selectedFeatureTypeDiv);
								});
								let returnDiv = creator.createDiv({text: "<i class='icon-Chevron-leftFill'></i>", css: "feature-property"});
								returnDiv.onclick = function(e){
									clickedProperty.innerHTML = "<div class='feature-property'> "+ key + ":" + value + "</div>";
									$('.feature-property').show();
									editing = false;
									e.stopPropagation();
								}
								let emptyDiv = creator.createDiv({css: "blankSpace"});
								prop.appendChild(emptyDiv);
								prop.appendChild(returnDiv);
							}else if(typeof value === "number" || (typeof value === "string" && !(parseInt(value).toString() == "NaN"))){
								editing = true;
								$('.feature-property').not(this).hide();
								let clickedProperty = this;
								clickedProperty.innerHTML = key;
								let sortedFeatures = privateFns.getRangeOfFeatureWithKey(key, layer);
								Object.entries(sortedFeatures).forEach(([key2, value2]) => {
									let selectedFeatureTypeDiv = creator.createDiv({text: key2, css: "feature-property"});
									$(selectedFeatureTypeDiv).on("mouseenter",function(){
										sortedFeatures[key2].forEach(function(sortedFeature){
											sortedFeature.setStyle(selectStyle2);
										});
									});
									$(selectedFeatureTypeDiv).on("mouseleave",function(){
										sortedFeatures[key2].forEach(function(sortedFeature){
											sortedFeature.setStyle(undefined);
										});
									});
									prop.appendChild(selectedFeatureTypeDiv);
								});
								let returnDiv = creator.createDiv({text: "<i class='icon-Chevron-leftFill'></i>", css: "feature-property"});
								returnDiv.onclick = function(e){
									clickedProperty.innerHTML = "<div class='feature-property'> "+ key + ":" + value + "</div>";
									$('.feature-property').show();
									editing = false;
									e.stopPropagation();
								}
								let emptyDiv = creator.createDiv({css: "blankSpace"});
								prop.appendChild(emptyDiv);
								prop.appendChild(returnDiv);
							}
						}
						document.getElementById("feature-info-panel").append(prop);
					});
					return true;
				}
			});
			if(!editing){					
				if ((new Date().getTime() - lastTime.getTime()) > 750 ) {
					if(!selected){
						document.getElementById("feature-info-panel").innerHTML = "";
						lastTime = new Date();
					}
				}else{
					lastTime = new Date();
				}
			}
		});
	},
	
	//ELLER TENK NYTT!!!
	// -Klikk på knapp for å vise fargehjul
	// -Klikk på knapp for å vise legge til border for å vise hvilken knapp som er aktiv
	// -klikk på fargehjul for å velge farge. 
	// -Skifte farge på knapp og resultatknapp
	// -Skifte farge på features ved valg av ny farge
	// -Legge til tekstfelt for bytte av farge og valg av andre farger enn oslofarger.
	createColorStyleContainer: function(){
		let styleContainer = creator.createDiv({css: "styleContainer"});
		let strokeColor = creator.createDiv({id: "strokeColor",css: "selectedColor"});
		let fillColor = creator.createDiv({id: "fillColor", css: "selectedColor"});
		let plusDiv = creator.createDiv({text: "+", css: "spacerDiv"});
		let equalsDiv = creator.createDiv({text: "=", css: "spacerDiv"});
		let displayExample = creator.createDiv({id: "selectedStyle", css: "selectedColor"});
		let colorPickerContainer = creator.createDiv({css: "colorPickerContainer"});
		strokeColor.onclick = function(){
			$(colorPickerContainer).show();
		};
		fillColor.onclick = function(){
			$(colorPickerContainer).show();
		};
		styleContainer.appendChild(strokeColor);
		
		styleContainer.appendChild(plusDiv);
		styleContainer.appendChild(fillColor);
		styleContainer.appendChild(equalsDiv);
		styleContainer.appendChild(displayExample);
		let colorPicker = creator.createUl({css: "colorPicker"});
		let colors = ["#2A2859", "#6FE9FF", "#B3F5FF", "#FF8274", "#034B45", "#43F8B6", "#C7F6C9", "#F9C66B", "#D0BFAE", "#F8F0DD"];
		colors.forEach(function(color){
			let colorLi = creator.createLi({});
			let colorDiv = creator.createDiv({css: "colorBackground"});
			colorDiv.style.background = color;
			colorLi.appendChild(colorDiv);
			colorPicker.appendChild(colorLi);
		});
		colorPickerContainer.appendChild(colorPicker);
		styleContainer.appendChild(colorPickerContainer);
		return styleContainer;
	},
	getAllFeatureWithKey: function(key, layer){
		let features = layer.getSource().getFeatures();
		let allValues = {};
		features.forEach(function(f){
			if(allValues[f.get(key)]){
				allValues[f.get(key)].push(f);
			}else{
				allValues[f.get(key)] = [];
			}
		});
		return allValues;
	},
	getRangeOfFeatureWithKey: function(key, layer){
		let features = layer.getSource().getFeatures();
		let minMax = privateFns.findFeatureMinMax(key, layer);
		let diff = 5;
		let range = (minMax.max - minMax.min) / diff;
		let allValues = {};
		for(let i = 0; i < diff; i++){
			allValues[minMax.min + range*i] = [];
		}
		features.forEach(function(f){
			let val = f.get(key);
			if(val < minMax.min + range){
				allValues[minMax.min].push(f);
			}else if(val < minMax.min + (2 * range)){
				allValues[minMax.min + range].push(f);
			}else if(val < minMax.min + (3 * range)){
				allValues[minMax.min + (2 * range)].push(f);
			}else if(val < minMax.min + (4 * range)){
				allValues[minMax.min + (3 * range)].push(f);
			}else{
				allValues[minMax.min + (4 * range)].push(f);
			}
			
		});
		return allValues;
	},
	findFeatureMinMax: function(key, layer){
		let features = layer.getSource().getFeatures();
		let minMax = {};
		features.forEach(function(f){
			if(minMax.min){
				minMax.min = minMax.min > f.get(key) ? f.get(key) : minMax.min;
			}else{
				minMax.min = f.get(key);
			}
			if(minMax.max){
				minMax.max = minMax.max < f.get(key) ? f.get(key) : minMax.max;
			}else{
				minMax.max = f.get(key);
			}
		});
		minMax.min = Math.floor(minMax.min)
		minMax.max = Math.ceil(minMax.max);
		return minMax;
	},
	addLayer: function(features, name){
		var vectorLayer = new Vector({
			source: new VectorSource({
				features: features,
			}),
			style: new Style({
				stroke: new Stroke({
					color: "#3366ff",
					width: 6
				}),
				fill: new Fill({
					color: "rgba(179, 198, 255,.3)"
				}),
				image: new Circle({
					radius: 7,
					fill: new Fill({color: "#6FE9FF"}),
					stroke: new Stroke({
						color: "#B3F5FF",
						width: 2,
					})
				})
			}),
		});
		vectorLayer.set('title', name);
		vectorLayer.id = name;
		globals.map.addLayer(vectorLayer);
		globals.map.getView().fit(
			vectorLayer.getSource().getExtent(),
			globals.map.getSize()
		);
		document.getElementById("layer-list").appendChild(privateFns.addImportLayer(vectorLayer, features));
		/*$("#layer-list").sortable({
			update: function(){					
				privateFns.orderLayers();
			},
			handle: ".handle",
			cursor: "move"
		});
		$("#layer-list li").droppable();*/
		document.getElementById("map-import-panel").innerHTML = "GeoJSON(.json), shp(.shp.zip), sosi(.sos), gdb(gdb.zip)";
	},
	addImportLayer: function (layer, features) {
		let properties = features[0].getProperties();
		let propertySelect = creator.createSelect({});
		var li, ct, id;
		id = layer.get("title");
		li = creator.createLi({id: id + "-swiper-container"});
		//li.setAttribute("draggable", true);
		//li.addEventListener("dragstart", privateFns.dragstart);
		//li.addEventListener('drop', privateFns.dropped);
		//li.addEventListener('dragenter', privateFns.cancelDefault);
		//li.addEventListener('dragover', privateFns.cancelDefault);
		ct = creator.createDiv({id: id.split(".")[0] + "-container"});
		let nameDiv = creator.createDiv({text: id});
		nameDiv.appendChild(privateFns.addLayerCheckBox(layer, id));
		nameDiv.appendChild(privateFns.addControlToggler(id.split(".")[0] + "-container"));
		nameDiv.appendChild(privateFns.addLayerRemover(id));
		//nameDiv.appendChild(privateFns.addLayerOrderBtn(id));
		li.appendChild(nameDiv);
		let swiper = privateFns.addLayerSlider(layer, id);
		ct.appendChild(swiper);
		privateFns.addSliderHandler(layer, swiper);
		let OPSlider = privateFns.addOpacitySlider(layer, id);
		ct.appendChild(OPSlider);
		privateFns.addOpacityHandler(layer, OPSlider);
		//Border
		let borderDiv = creator.createDiv({text: "Grense"});
		ct.appendChild(borderDiv);
		let borderSlider = privateFns.addBorderSlider(layer, id);
		ct.appendChild(borderSlider);
		privateFns.addBorderHandler(layer, borderSlider);
		ct.appendChild(privateFns.createBorderColorRow(layer));
		//Fill
		let flateDiv = creator.createDiv({text: "Flate"});
		let flateCheck = creator.createInput({type: "checkbox"});
		flateCheck.checked = true;
		let transparency;  
		flateCheck.onclick = function(){
			if(flateCheck.checked){
				layer.getStyle().fill_.color_ = layer.getStyle().fill_.color_.replace(/[^,]+(?=\))/, transparency);
			}else{
				transparency = layer.getStyle().fill_.color_.split(",")[3].slice(0,-1);
				layer.getStyle().fill_.color_ = layer.getStyle().fill_.color_.replace(/[^,]+(?=\))/, '0');
			}
			layer.getSource().changed();
		};
		flateDiv.appendChild(flateCheck);
		ct.appendChild(flateDiv);
		ct.appendChild(privateFns.createFillColorRow(layer));
		li.appendChild(ct);
		ct.style.display = "none";
		$(li).show();
		return li;
	},
	addLayerRemover: function(id){
		let btn = creator.createButton({});
		btn.style.float = "right";
		let icon = creator.createIcon({css: "icon-Close"});
		icon.style.fontWeight = "bolder";
		btn.appendChild(icon);
		btn.onclick = function(e){
			globals.map.removeLayer(globals.map.getLayerByName(id));
			$(e.currentTarget).parent().parent()[0].remove();
		}
		return btn;
	},
	addLayerOrderBtn: function(id){
		let span = creator.createSpan({css: "handle"});
		span.style.float = "right";
		let icon = creator.createIcon({css: "fa fa-arrows"});
		icon.style.fontWeight = "bolder";
		span.appendChild(icon);
		return span;
	},
	addControlToggler: function(id){
		let btn = creator.createButton({});
		btn.style.marginLeft = "5px";
		let icon = creator.createIcon({css: "icon-Chevron-down"});
		btn.appendChild(icon);
		btn.onclick = function(){
			$("#"+id).toggle();
			$("#"+id).parent().attr('draggable', !$("#"+id).is(":visible"));
			$(icon).toggleClass("icon-Chevron-down");
			$(icon).toggleClass("icon-Chevron-upFill");
		}
		return btn;
	},
	addLayerCheckBox: function(layer, id){
		var input = creator.createInput({type: "checkbox"});
		input.style.marginLeft = "10px";
		input.checked = true;
		$(input).click(function (e) {
			layer.setVisible(this.checked);				
		});
		return input;
	},
	addLayerSlider: function(layer, id){
		var swiper = creator.createInput({type: "range", id: id + "-swipe"});
		swiper.value = 0;
		return swiper;
	},
	addOpacitySlider: function(layer, id){
		var slider = creator.createInput({type: "range", id: id + "-opacity"});
		slider.value = 100;
		return slider;
	},
	addBorderSlider: function(layer, id){
		var slider = creator.createInput({type: "range", id: id + "-border"});
		slider.value = 6;
		return slider;
	},
	addSliderHandler: function(layer, swipe){
		layer.on('precompose', function(event) {
			var ctx = event.context;
			var width = ctx.canvas.width * (swipe.value / 100);
			ctx.save();
			ctx.beginPath();
			ctx.rect(width, 0, ctx.canvas.width - width, ctx.canvas.height);
			ctx.clip();
		});

		layer.on('postcompose', function(event) {
			var ctx = event.context;
			ctx.restore();
		});

		swipe.addEventListener('input', function() {
			layer.getSource().changed();
		}, false);
	},
	addOpacityHandler: function(layer, swipe){
		swipe.addEventListener('input', function() {
			layer.setOpacity(swipe.value/100);
			layer.getSource().changed();
		}, false);
	},
	addBorderHandler: function(layer, swipe){
		swipe.addEventListener('input', function() {
			layer.getStyle().stroke_.width_ = swipe.value;
			layer.getSource().changed();
		}, false);
	},
	createBorderColorRow: function(currentLayer){
		var colorPallet = creator.createDiv({
			css: "color-pallet",
			id: "colorPallet",
		});
		var btns = ["mBlaBtn", "blaBtn", "lBlaBtn", "rodBtn", "mGronnBtn", "gronnBtn", "lGronnBtn", "sortBtn", "gulBtn", "mBeigeBtn", "beigeBtn"];
		btns.forEach(function(btn){
			colorPallet.appendChild(creator.createButton({
				css: btn + " colorBtn",
				id:currentLayer.id + "-Border" + btn,
				onclick: function(e){
					$(".selectedBtn").removeClass("selectedBtn");
					$("#"+e.target.id).toggleClass("selectedBtn");
					currentLayer.getStyle().stroke_.color_ = $("#"+e.target.id).css("color");
					currentLayer.changed();
				}
			}));
			
		});
		return colorPallet;
	},
	createFillColorRow: function(currentLayer){
		var colorPallet = creator.createDiv({
			css: "color-pallet",
			id: "colorPallet",
		});
		var btns = ["mBlaBtn", "blaBtn", "lBlaBtn", "rodBtn", "mGronnBtn", "gronnBtn", "lGronnBtn", "sortBtn", "gulBtn", "mBeigeBtn", "beigeBtn"];
		btns.forEach(function(btn){
			colorPallet.appendChild(creator.createButton({
				css: btn + " colorBtn",
				id:currentLayer.id + "-Row" + btn,
				onclick: function(e){
					$(".selectedBtn").removeClass("selectedBtn");
					$("#"+e.target.id).toggleClass("selectedBtn");
					currentLayer.getStyle().fill_.color_ = $("#"+e.target.id).css("color");
					currentLayer.changed();
				}
			}));
			
		});
		return colorPallet;
	},
	deactivate: function(btn){
		var panel = $("#map-import-container");
		var interactions = mapInteractions.getActiveInteractions();
		globals.map.removeInteraction(parameters.interaction);
		panel.hide();
		globals.mapclick = true;
		if (interactions.mapClickInteraction) {
			interactions.mapClickInteraction.setActive(true);
		}
		interactions.mapHoverInteraction.setActive(true);
		if(btn.removeClass){
			btn.removeClass("selected");
			btn.blur();
		}
	},
	importClick: function(e){
		var panel = $("#map-import-container");
		var btn = $(e.currentTarget);
		btn.toggleClass("selected");
		if (!btn[0].classList.contains("selected")) {
			privateFns.deactivate(btn);
		} else {
			if(panel[0]){
				panel.show();
			}else{
				privateFns.addImportControlPanel();
			}
		}
	},
	orderLayers: function(){
		let importLayers = document.getElementById("layer-list").getElementsByTagName("li");
		for(let i = 0; i < importLayers.length; i++){
			globals.map.getLayerByName(importLayers[i].id.replace("-swiper-container","")).setZIndex(importLayers.length - i);
		}
	},
};

// Legg til ekstra css-filer
$("head").append("<link rel='stylesheet' type='text/css' href='css/layerImportPlugin.css'>");
//$("head").append('<script src="' + worldPath + 'js/vendor/sosi.js-master/dist/SOSI.js"></script>');
export default {
	registerPluginFunction(registerFunction, callback){
		registerFunction({
			id: "layer-import",
			deactivate: privateFns.deactivate, 
			clear: [privateFns.clearFunction],
			userGuide:{
				img: {type: "icon", className: "fa fa-upload"},
				text: "Åpner meny for å laste kartfiler. Dra og slipp dem i menyn for å se dem i kartet. Sosi må være UTF-8 encoded. Gyldige formater er geojson(.json), sosi(.sos), gdb(.gdb.zip), shape (.shp.zip)",
			},
			onclick: privateFns.importClick,
			deactivate: privateFns.deactivate,
		}, callback);
	},
};